module.exports = __webpack_public_path__ + "static/media/locknox-4.b56e88b8.jpg";